export const DemolitionB1NavOptions = [
  {
    label: 'a) druh a účel užívání odstraňované stavby',
    target: 'b1a',
  },
  {
    label: 'b) stávající parametry odstraňované stavby',
    target: 'b1b',
  },
  {
    label: 'c) stručný popis stavebních objektů',
    target: 'b1c',
  },
  {
    label: 'd) stávající ochranná a bezpečnostní pásma',
    target: 'b1d',
  },
  {
    label: 'e) způsob zajištění ochrany stávajících staveb civilní ochrany',
    target: 'b1e',
  },
  {
    label: 'f) poloha vzhledem k záplavovému území',
    target: 'b1f',
  },
  {
    label: 'g) výsledky stavebního průzkumu',
    target: 'b1g',
  },
  {
    label: 'h) vliv odstranění stavby na okolí',
    target: 'b1h',
  },
  {
    label: 'i) zhodnocení kontaminace prostoru staveb',
    target: 'b1i',
  },
  {
    label: 'j) požadavky na kácení dřevin',
    target: 'b1j',
  },
  {
    label: 'k) seznam sousedních pozemků',
    target: 'b1k',
  },
  {
    label: 'l) informace o zohlednění podmínek závazných stanovisek',
    target: 'b1l',
  },
  {
    label: 'm) základní předpoklady pro odstranění stavby',
    target: 'b1m',
  },
  {
    label: 'n) seznam výsledků zeměměřických činností',
    target: 'b1n',
  },
]
